import React from 'react'
import { Link } from 'react-router-dom'
import { Lock } from 'lucide-react'
import { useLang } from '../context/LangContext'

/**
 * Pantalla para cuando alguien llega a una ruta que no tiene permiso de ver.
 *
 * Antes se redirigía en silencio a /inicio. Con enlaces que se comparten por
 * fuera de la aplicación —un artículo de la wiki que alguien le manda a un
 * cliente— eso deja a la persona en la portada sin entender qué pasó, y con la
 * sospecha razonable de que el link estaba roto. Acá se le dice qué pasó.
 */
export const SinPermiso: React.FC<{ permisos?: string[] }> = ({ permisos }) => {
  const { t } = useLang()
  const tp: any = (t as any).sinPermiso ?? {}
  return (
    <div className="sin-permiso">
      <div className="sin-permiso__icon"><Lock size={28} /></div>
      <h2 className="sin-permiso__title">{tp.title ?? 'No tenés permiso para ver esta página'}</h2>
      <p className="sin-permiso__text">
        {tp.text ?? 'El enlace es correcto, pero tu usuario no tiene habilitada esta sección. Pedile acceso a quien administra tu cuenta.'}
      </p>
      {permisos?.length ? (
        <p className="sin-permiso__perm">
          {(tp.needed ?? 'Permiso necesario: {p}').replace('{p}', permisos.join(' o '))}
        </p>
      ) : null}
      <Link to="/inicio" className="btn btn--primary sin-permiso__btn">{tp.back ?? 'Ir al inicio'}</Link>
    </div>
  )
}
